import type { CanonicalAccount } from '@/api/hooks/useAccounts';
import type { ReconciliationLaunch } from './ReconciliationReviewPanel';

export type ReviewLaunchEligibility =
  // `uncertain` carries the emphasis the host should give the launch; it never
  // affects eligibility, so an unsettled match is reviewable exactly like any
  // other.
  | { kind: 'eligible'; launch: ReconciliationLaunch; uncertain: boolean }
  | { kind: 'no_target' }
  | { kind: 'ambiguous' }
  | { kind: 'setup' };

export function classifyReviewLaunch(
  account: Pick<CanonicalAccount, 'canonical_account_id' | 'reconciliation_initialization_required' | 'active_item_ids' | 'reconnect_match_status'>,
): ReviewLaunchEligibility {
  if (account.canonical_account_id === null || account.reconciliation_initialization_required) {
    return { kind: 'setup' };
  }
  if (account.active_item_ids.length === 0) return { kind: 'no_target' };
  if (account.active_item_ids.length !== 1) return { kind: 'ambiguous' };
  return {
    kind: 'eligible',
    launch: {
      canonicalAccountId: account.canonical_account_id,
      replacementItemId: account.active_item_ids[0],
    },
    uncertain: account.reconnect_match_status === 'auto_match_uncertain',
  };
}
